module.exports = "/_next/static/images/icon_plus_circle-bcd5b8833ddde72cac431dbc4e5472d9.svg";